__webpack_require__.p = "https://cdn.brandwatch.com/shared-dashboard-wrapper/7f1174f32d03c968e3daf14f24655c28372c791e/";